// extracted by mini-css-extract-plugin
export default {"wrapper":"j7ycDFPh65","focus":"kqruROEOop","read-only":"iMEgGqHXmL","readOnly":"iMEgGqHXmL"};